/* //* Package imports */
import ReactDOM from "react-dom";

/* //* Component imports */
import App from "./App";

/* //* Style imports */
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));
